<div class="content-scroll-down" [class.contraste]="this.contrasteAtivo">
    <button class="btn-scrollDown" (click)="scrollDown()">
    <i class="fas fa-chevron-down"></i>
  </button>
</div>